import { render, staticRenderFns } from "./acceptEvents.vue?vue&type=template&id=2a1b18bf&scoped=true&"
import script from "./acceptEvents.vue?vue&type=script&lang=js&"
export * from "./acceptEvents.vue?vue&type=script&lang=js&"
import style0 from "./acceptEvents.vue?vue&type=style&index=0&id=2a1b18bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b18bf",
  null
  
)

export default component.exports